import { FunctionComponent, useState } from "react";
import { PaginatedGrid } from "../../../../../components/Grid";
import Title from "../../../../../components/Title";
import {
  SigmaDetection,
  SigmaDetectionSource
} from "../../../@types/rldynamicanalysis";
import { DYNAMIC_ANALYSIS_EMPTY_MESSAGES } from "../consts";
import RlCloudSandboxSigmaDetectionsGridRow from "./RlCloudSandboxSigmaDetectionsGridRow";

const EMPTY_CELL_CONTENT = "- - -";

type RlCloudSandboxSigmaDetectionsProps = {
  data: SigmaDetection[];
  reportTitle: string;
};

const SCHEMA = {
  fields: [
    {
      name: "description",
      displayTitle: "Description",
      component: (item: SigmaDetection) =>
        item.description || EMPTY_CELL_CONTENT
    },
    {
      name: "source",
      displayTitle: "Source",
      component: (item: SigmaDetectionSource) =>
        item.source || EMPTY_CELL_CONTENT,
      isArrayField: true
    },
    {
      name: "details",
      displayTitle: "Details",
      component: (item: SigmaDetectionSource) =>
        item.details || EMPTY_CELL_CONTENT,
      isArrayField: true
    }
  ]
};

const RlCloudSandboxSigmaDetections: FunctionComponent<
  RlCloudSandboxSigmaDetectionsProps
> = ({ data, reportTitle }) => {
  const [pageNum, setPageNum] = useState(1);
  const [currentPageSize, setCurrentPageSize] = useState(10);

  const pageData =
    data?.slice((pageNum - 1) * currentPageSize, pageNum * currentPageSize) ||
    [];

  return (
    <div>
      <Title Level="h2" text={`Sigma Detections (${reportTitle})`} />

      {data?.length ? (
        <PaginatedGrid
          data={pageData}
          numPages={Math.ceil(data?.length / currentPageSize)}
          schema={SCHEMA}
          page={pageNum}
          pageSize={currentPageSize}
          totalResults={data?.length || 0}
          showPageNumbers
          GridRowComponent={RlCloudSandboxSigmaDetectionsGridRow}
          onPageChange={(value: number, pageSize: number) => {
            setPageNum(value);
            setCurrentPageSize(pageSize);
          }}
        />
      ) : (
        <b>{DYNAMIC_ANALYSIS_EMPTY_MESSAGES.sigma_detections}</b>
      )}
    </div>
  );
};

export default RlCloudSandboxSigmaDetections;
